/**
 * Runs `inject` after `window` `load` when `injectAfterPageLoad` is true and the document is not
 * already complete; otherwise runs `inject` immediately. Returns a cleanup that removes the load
 * listener when one was registered.
 */
export function subscribeTrinityInjectOnWindowLoad(
  inject: () => void,
  injectAfterPageLoad: boolean
): (() => void) | undefined {
  if (!injectAfterPageLoad || document.readyState === 'complete') {
    inject();
    return undefined;
  }

  const onWindowLoad = () => inject();
  window.addEventListener('load', onWindowLoad, { once: true });
  return () => window.removeEventListener('load', onWindowLoad);
}
